/** @format */

import {
  setAdvancedQuestion,
  setBasicQuestion,
  setIntermediateQuestion,
} from "../../redux/action/interviewQuestions";
import apis from "../../utils/apis"; // Replace with your API library import

export function fetchInterviewQuestions(
  dispatch,
  skill,
  advancedQuestionsStore,
  intermediateQuestionsStore,
  basicQuestionsStore,
  setAdvancedQuestions,
  setIntermediateQuestions,
  setBasicQuestions,
  setInterviewQuestions,
  setInterviewQuestionsLoading,
  setAdvancedQuestionsLoading,
  setIntermediateQuestionsLoading,
  setBasicQuestionsLoading,
  selectedTab
) {
  const levels = {
    basic: "get-interviewQuestion-basic",
    intermediate: "get-interviewQuestion-intermediate",
    advanced: "get-interviewQuestion-advanced",
  };

  const MAX_RETRIES = 3;

  const fetchLevelData = async (
    levelKey,
    setLoading,
    setQuestionData,
    setQuestion,
    retries = 0
  ) => {
    setLoading(true);

    try {
      const response = await apis.GET({
        endpoint: `/${levels[levelKey]}?skill=${skill?.name}`,
        options: { type: "json" },
      });
      // console.log("Skill", skill?.name);

      const data = response.data.questions;
      // console.log(`✅ Data fetched successfully for ${levelKey}:`, data);

      setInterviewQuestions((prev) => ({ ...prev, [levelKey]: data || [] }));
      dispatch(setQuestion(data));
      setQuestionData(data);
    } catch (error) {
      console.error(`❌ API call failed for ${levelKey}:`, error);

      if (
        (error?.response?.status === 504 ||
          error?.response?.data?.status === 400) &&
        retries < MAX_RETRIES
      ) {
        // console.log(`🔄 Retrying API call for ${levelKey}... Attempt ${retries + 1}`);
        return fetchLevelData(levelKey, setLoading, retries + 1);
      } else {
        console.error(
          `🚨 Non-retryable error or retry limit reached for ${levelKey}.`
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestionsByTab = async () => {
    setInterviewQuestionsLoading(true);
    // console.log("basicQuestionsStore", basicQuestionsStore?.length);
    // console.log("selectedTab", selectedTab);

    if (selectedTab === "advanced") {
      if (advancedQuestionsStore?.length === 0) {
        // console.log("advancedQuestionsStore-called");
        await fetchLevelData(
          "advanced",
          setAdvancedQuestionsLoading,
          setAdvancedQuestions,
          setAdvancedQuestion
        );
      }
    } else if (selectedTab === "intermediate") {
      if (intermediateQuestionsStore?.length === 0) {
        await fetchLevelData(
          "intermediate",
          setIntermediateQuestionsLoading,
          setIntermediateQuestions,
          setIntermediateQuestion
        );
      }
    } else if (selectedTab === "basic") {
      if (basicQuestionsStore?.length === 0) {
        await fetchLevelData(
          "basic",
          setBasicQuestionsLoading,
          setBasicQuestions,
          setBasicQuestion
        );
      }
    } else {
      console.warn(`⚠️ Unknown selectedTab: ${selectedTab}`);
    }

    setInterviewQuestionsLoading(false);
  };

  fetchQuestionsByTab(); // Call the function based on selectedTab
}

export const fetchDisruptCareerData = (
  item,
  relevanceResult,
  setDisruptCareerData,
  setDisruptCareerLoading
) => {
  const MAX_RETRIES = 3;

  const fetchDisruptCareerData = async (retries = 0) => {
    try {
      setDisruptCareerLoading(true);
      const response = await apis.GET({
        endpoint: `/get-disrupt-career?skill=${item?.name}&id=${relevanceResult?.relevanceResultId}`,
      });
      setDisruptCareerData(response.data.content);
    } catch (error) {
      console.error(`❌ API call failed for get-disrupt-career:`, error);

      if (
        (error?.response?.status === 504 ||
          error?.response?.data?.status === 400) &&
        retries < MAX_RETRIES
      ) {
        // console.log(
        //   `🔄 Retrying API call for get-disrupt-career... Attempt ${
        //     retries + 1
        //   }`
        // );
        return fetchDisruptCareerData(retries + 1);
      } else {
        console.error(
          `🚨 Non-retryable error or retry limit reached for get-disrupt-career.`
        );
      }
    } finally {
      setDisruptCareerLoading(false);
    }
  };
  fetchDisruptCareerData();
};
